import styled from 'styled-components';

export const PlaceholderContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%
  padding: 40px;
  width: 100%;
`;
